import { NavigationType as GeneratedNavigationType } from "./__generated__/ImportedNavigationItemsQuery.graphql";

export const NavigationType = {
  MENU: "MENU" as GeneratedNavigationType,
  SHORTCUTS: "SHORTCUTS" as GeneratedNavigationType,
} as const;
